import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=64f52e62&scoped=true"
var script = {}
import style0 from "./Goals.vue?vue&type=style&index=0&id=64f52e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f52e62",
  null
  
)

export default component.exports